import { render, staticRenderFns } from "./CtaFooter.vue?vue&type=template&id=21cf775c&scoped=true&"
import script from "./CtaFooter.vue?vue&type=script&lang=js&"
export * from "./CtaFooter.vue?vue&type=script&lang=js&"
import style0 from "./CtaFooter.vue?vue&type=style&index=0&id=21cf775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf775c",
  null
  
)

export default component.exports